import { render, staticRenderFns } from "./packageRenewal.vue?vue&type=template&id=4d937dd0&scoped=true&"
import script from "./packageRenewal.vue?vue&type=script&lang=js&"
export * from "./packageRenewal.vue?vue&type=script&lang=js&"
import style0 from "./packageRenewal.vue?vue&type=style&index=0&id=4d937dd0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d937dd0",
  null
  
)

export default component.exports